import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
var formatToList = function(items) {
    return items.map(function(key) {
        return "- ".concat(key);
    }).join("\n");
};
export default function validatePathConfig(config) {
    var root = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var validKeys = [
        "initialRouteName",
        "screens"
    ];
    if (!root) {
        validKeys.push("path", "exact", "stringify", "parse");
    }
    var invalidKeys = Object.keys(config).filter(function(key) {
        return !validKeys.includes(key);
    });
    if (invalidKeys.length) {
        throw new Error("Found invalid properties in the configuration:\n".concat(formatToList(invalidKeys), "\n\nDid you forget to specify them under a 'screens' property?\n\nYou can only specify the following properties:\n").concat(formatToList(validKeys), "\n\nSee https://reactnavigation.org/docs/configuring-links for more details on how to specify a linking configuration."));
    }
    if (config.screens) {
        Object.entries(config.screens).forEach(function(param) {
            var _param = _sliced_to_array(param, 2), _ = _param[0], value = _param[1];
            if (typeof value !== "string") {
                validatePathConfig(value, false);
            }
        });
    }
}
